import React, { useState } from 'react';

const InspectionResolutionModal = ({ 
  isOpen, 
  onClose, 
  address,
  contract, 
  onSubmit
}) => {
  const [resolutionText, setResolutionText] = useState('');

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <h2 className="text-xl font-semibold mb-4">Inspection Resolution</h2>
        <p className="text-sm text-gray-700 mb-4">
          You are about to submit an Inspection resolution on <span className="font-bold">{address}</span>. Describe what the seller agree's to do to resolve your original objection.
        </p>
        <textarea 
          className="w-full border rounded p-2 mb-4"
          rows="5"
          value={resolutionText}
          onChange={(e) => setResolutionText(e.target.value)}
          placeholder="Enter your objection details here..."
        />
        <p className="text-xs text-gray-600 mb-4">
        NOTE: Any agreement on inspection issues may change your contract and might need to be reported to your lender. Please consult your lender before finalizing any resolution, as changes could affect your loan, delay funding, or require extra repairs.
        <br />
        <br />
        If you and the seller don't agree in writing by the Inspection Resolution Deadline, the contract will terminate—unless you withdraw your inspection objection before the deadline.
        </p>
        <div className="flex justify-end gap-4">
          <button 
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button 
            onClick={() => onSubmit(resolutionText, contract)}
            className="px-4 py-2 bg-shi-green text-white rounded hover:bg-green-700"
          >
            Sign and Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default InspectionResolutionModal;
